<template>
  <div class="main">

    <div class="pageTitle">
     <p>{{roleName}}</p>
      <el-button type="text" class="defaultBtn" @click="backPage" style="margin-left:20px;">返回角色列表</el-button>
    </div>

    <div class="roleDetailMain">
      <div class="mainContent" style="margin-top: 60px;">
        <el-tabs v-model="activeName">

           <el-tab-pane label="基本信息" name="roleInfo">
            <div class="tabContent">
              <div>
                 <el-row :gutter="0">
                  <el-col :span="10">
                   <el-form
                    :model="roleBaseInfo"
                    label-position="left"
                    ref="roleBaseInfo"
                    size="small"
                    :rules="roleBaseInfoRules"
                    label-width="80px"
                    @submit.native.prevent>
                    <el-form-item label="名称:" prop="name">
                      <el-input v-model="roleBaseInfo.name" autocomplete="off"></el-input>
                    </el-form-item>
                  </el-form>
                   <div style="margin-top:20px;">
                      <el-button size="small" class="delete_btn" type="danger" plain @click="removeRole()">删除</el-button>
                      <el-button size="small" @click="updateRoleBaseInfo()" style="margin-left:50px;">保存</el-button>
                   </div>
                  </el-col>
                  <el-col :span="14">
                        
                  </el-col>
              </el-row> 
              </div>
            </div>
          </el-tab-pane>

          <el-tab-pane label="配置权限" name="settingRole">
            <div class="tabContent">
              <div>
                <el-button  size="small" @click="updateRoleAuthorization">保存</el-button>
                <span class='font_14' style="margin-left:20px;">修改权限后请点击保存</span>
            </div>
            <div style="margin-top:20px">
               <el-tree
                ref="tree"
                :key="tree_key"
                :data="treeData"
                show-checkbox
                node-key="roleKey"
                :props="defaultProps"
                :expand-on-click-node="true"
                :default-expanded-keys="openKey"
                :default-checked-keys="checkKey"
                :highlight-current="false">
                </el-tree>
            </div>
            </div>
          </el-tab-pane>

          <el-tab-pane label="配置人员" name="settingUser">
            <div class="tabContent">
              <el-form
              label-position="left"
              size="small"
              label-width="80px"
              class="searchForm"
              :inline="true">
              <el-form-item label="关键字:">
                <el-input v-model="userlistQuery.Parameters.keyword" autocomplete="off" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-button @click="searchTable">查询</el-button>
              <el-button @click="showChooseUserView" >新增</el-button>
              </el-form-item>
              </el-form>
            </div>
             <div class="tableContainer" style="top: 60px;">
                <div class="tableContent">
                    <el-table :data="userList" border stripe>
                      <el-table-column type="index" width="50" label="NO"></el-table-column>
                      <el-table-column prop="name" label="姓名">
                      </el-table-column>
                      <el-table-column prop="organizationName" label="组织机构"></el-table-column>
                      <el-table-column prop="account" label="登录账户"></el-table-column>
                      <el-table-column prop="cellphone" label="电话"></el-table-column>
                      <el-table-column prop="email" label="邮箱"></el-table-column>
                      <!-- <el-table-column prop="createTime" label="创建时间"></el-table-column> -->
                      <el-table-column prop="name" label="操作" width="120">
                        <template slot-scope="props">
                          <el-button  type="text" size="mini" @click="removeUserFormRole(props.row)" class="removeBtn">移除</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                </div>
                  
                <div class="tablePagesNumber">
                        <el-pagination
                          @size-change="handleSizeChange"
                          @current-change="handleCurrentChange"
                          :current-page="userlistQuery.PagingInfo.currentPage"
                          :page-sizes="[10, 50, 100, 200]"
                          :page-size="userlistQuery.PagingInfo.pageSize"
                          layout="total, sizes, prev, pager, next, jumper"
                          :total="userlistQuery.PagingInfo.totalCount"></el-pagination>
                </div>
            </div>
          </el-tab-pane>
        </el-tabs>

      <chooseMultipleUser ref="chooseMultipleUser" :propsData="chooseMultipleUserPropsData" 
          @chooseMultipleUserCallback="chooseMultipleUserCallback">
      </chooseMultipleUser>

      </div>
    </div>
  </div>
  
</template>
<script>
import chooseMultipleUser from "../common/chooseMultipleUser"
import roleList from '../../router/roleList.js'
export default {
  name: "roleDetail",
 components: {chooseMultipleUser },
  props: [],
  data() {
    return {
      chooseMultipleUserPropsData:{
        visible:false
      },
      roleBaseInfo: {
        name: "",
        id: ""
      },
      tree_key: 0,
      queryParams: {},
      roleName:'',
      activeName:"settingRole",
      treeData: [],
      userList: [],
      roleSetting:{
        roleId:'',
        roleAuthorization:[]
      },
      checkKey:[],
      openKey:['WeeklyReport','Project','Settings','Report'],
      userlistQuery: {
        PagingInfo: {
          currentPage: 1,
          totalPage: 0,
          pageSize: 10,
          totalCount: 0
        },
        OrderBy: "",
        Parameters: {
          keyword: "",
          roleId:'',
        }
      },
      defaultProps: {
        children: "children",
        label: "name"
      },
      roleBaseInfoRules: {
        name: [{ required: true, message: "请输入角色名称", trigger: "blur" }]
      },
    };
  },
  created() {
    this.queryParams = this.$route.query;
    this.userlistQuery.Parameters.roleId=this.queryParams.id;
     this.treeData = roleList;
    this.getRoleBaseInfo();
    this.getRole();
    this.getUserList();
  },
  methods: {
     updateRoleAuthorization(){
      this.roleSetting.roleId = this.queryParams.id;
      let authorizationKey = this.$refs.tree.getCheckedNodes();
       this.roleSetting.roleAuthorization = authorizationKey.map(item=>
       {
        return {authorizationKey:item.roleKey}
      })

      //console.log(  this.roleSetting);
        this.$roleApi
        .updateRoleAuthorization(this.roleSetting)
        .then(res => {
          if (res.data.successful) {
             this.$message({
              message: "保存成功",
              type: "success",
              customClass: "successMsg",
              duration: 2000
            });
          } else {
            this.$alert(res.data.message, "提示");
          }
        })
        ;
    },
   
    showChooseUserView() {
      this.$refs.chooseMultipleUser.show();
    },

    //获取角色信息
    getRole() {
      let id = this.queryParams.id;
      this.$roleApi.getRole(id)
        .then(res => {
          if (res.data.successful) 
          {
            let dataList = res.data.data.roleAuthorization;
             this.checkKey = dataList.map(item=>
             {
               return item.authorizationKey
             })
          } else 
          {
            this.$alert(res.data.message, "提示");
          }
        });
    },

    //获取用户信息
    getUserList() {
       this.$userApi.getUserList(this.userlistQuery)
        .then(res => {
          if (res.data.successful) 
          {
            this.userList=res.data.data.data;
            this.userlistQuery.PagingInfo.totalCount=res.data.data.pagingInfo.totalCount
          } 
          else 
          {
            this.$alert(res.data.message, "提示");
          }
        })
       ;
    },
    searchTable() {
      this.getUserList();
    },

    chooseMultipleUserCallback(userIdArray){
        
      let submitData = {
        roleId: this.queryParams.id,
        userIdArray:userIdArray
      };

      this.$roleApi.addUserListToRole(submitData).then(res => {
        if (res.data.successful) {
          this.getUserList();
        } else {
          this.$alert(res.data.message, "提示");
        }
      });

    },

    removeUserFormRole(currentLine) {
      let args = {roleId:this.queryParams.id,userId:currentLine.id}
          this.$roleApi
            .removeUserFormRole(args)
            .then(res => {
              if (res.data.successful) {
                this.getUserList();
              } else {
                this.$alert(res.data.message, "提示");
              }
            })
           ;
    },
    handleSizeChange(val) {
      this.userlistQuery.PagingInfo.pageSize = val;
      this.getUserList();
    },
    handleCurrentChange(val) {
      this.userlistQuery.PagingInfo.currentPage = val;
      this.getUserList();
    },
    backPage() {
      this.$router.push({ path: "/setting/role" });
    },
    getRoleBaseInfo() {
      this.$roleApi.getRoleBaseInfo(this.queryParams.id).then(res => {
        if (res.data.successful) {
          this.roleBaseInfo = res.data.data;
          this.roleName = res.data.data.name;
        } else {
          this.$alert(res.data.message, "提示");
        }
      });
    },
    updateRoleBaseInfo() {
      this.$refs["roleBaseInfo"].validate(valid => 
      {
        if (!valid) 
          return;
        let submitForm = JSON.parse(JSON.stringify(this.roleBaseInfo));

        this.$roleApi.updateRoleBaseInfo(submitForm).then(res => 
        {
            if (res.data.successful) {
              this.roleName = this.roleBaseInfo.name;
               this.$alert("更新成功。", "提示");
            } else {
              this.$alert(res.data.message, "提示");
            }
          });
      });
    },
    removeRole() {
      this.$confirm("是否确定删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$roleApi.removeRole(this.roleBaseInfo.id).then(res => {
          if (res.data.successful) {
            this.backPage();
          } else {
            this.$alert(res.data.message, "提示");
          }
        });
      });
    },
  }
};
</script>
<style rel="stylesheet/scss" lang="scss">

.roleDetailMain
{
   .mainContent{
  //   background-color:burlywood;
      top: 0px;
      bottom: 30px;
      left: 0px;
      right: 20px;
      position: absolute;
  }

.el-tabs{
    //  background-color:cornflowerblue;
    //  min-height: calc(100vh - 250px) !important;
      top: 0px;
      bottom: 0px;
      left: 0px;
      right: 0px;
      position: absolute;
  }

  .el-tabs__content{
      top: 50px ;
      bottom: 0px ;
      left: 0px  ;
      right: 0px ;
      position: absolute  !important;
  }

  .el-tab-pane{
    //  background-color:aqua  !important;
        // height: 100%;
      top: 0px  !important;
      bottom: 0px  !important;
      left: 0px  !important;
      right: 0px  !important;
      position: absolute  !important;
  }

  .detailTabContent{
    width: 600px;
    padding:0 20px;
  }
  
  .tabContent{
    margin-top: 10px;
    padding:0 20px;
  }
  .bigBtn{
    font-size: 20px;
    margin-right: 20px;
  }
  .font_14{
    font-size: 14px;
    color: #777777;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/setting/roleDetail.vue